"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/webview/index.ts
var webview_exports = {};
__export(webview_exports, {
  AppToWebViewEvent: () => AppToWebViewEvent,
  WebViewToAppMessageEvent: () => WebViewToAppMessageEvent,
  getWebViewAuthToken: () => getWebViewAuthToken,
  sendAuthTokenResponse: () => sendAuthTokenResponse,
  sendDownloadMessage: () => sendDownloadMessage,
  sendLogoutMessage: () => sendLogoutMessage,
  sendNavigationMessage: () => sendNavigationMessage
});
module.exports = __toCommonJS(webview_exports);
var WebViewToAppMessageEvent = {
  LOGOUT: "logout",
  NAVIGATION: "navigation",
  REQUEST_AUTH_TOKEN: "request_auth_token",
  DOWNLOAD: "download"
};
var AppToWebViewEvent = {
  AUTH_TOKEN_RESPONSE: "auth_token_response"
};
var sendWebViewMessage = (message) => {
  if (typeof window === "undefined") {
    return;
  }
  const nativeWindow = window;
  const reactNativeWebView = nativeWindow.ReactNativeWebView;
  if (reactNativeWebView?.postMessage) {
    reactNativeWebView.postMessage(JSON.stringify(message));
  }
};
var sendDownloadMessage = (payload) => {
  sendWebViewMessage({
    event: WebViewToAppMessageEvent.DOWNLOAD,
    payload
  });
};
var getWebViewAuthToken = () => {
  if (typeof window === "undefined") {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    const listener = (event) => {
      const data = JSON.parse(event.data);
      if (data.event === AppToWebViewEvent.AUTH_TOKEN_RESPONSE) {
        window.removeEventListener("message", listener);
        resolve(data.payload.token);
      }
    };
    window.addEventListener("message", listener);
    sendWebViewMessage({
      event: WebViewToAppMessageEvent.REQUEST_AUTH_TOKEN,
      payload: void 0
    });
  });
};
var sendLogoutMessage = () => {
  sendWebViewMessage({
    event: WebViewToAppMessageEvent.LOGOUT,
    payload: void 0
  });
};
var sendNavigationMessage = (url) => {
  sendWebViewMessage({
    event: WebViewToAppMessageEvent.NAVIGATION,
    payload: { url }
  });
};
var sendAuthTokenResponse = (webviewRef, token) => {
  const message = {
    event: AppToWebViewEvent.AUTH_TOKEN_RESPONSE,
    payload: { token }
  };
  webviewRef.current?.postMessage(JSON.stringify(message));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AppToWebViewEvent,
  WebViewToAppMessageEvent,
  getWebViewAuthToken,
  sendAuthTokenResponse,
  sendDownloadMessage,
  sendLogoutMessage,
  sendNavigationMessage
});
